
import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";
import * as jose from 'jose'

export const  Crypto = async (data) => {
    try {
        const jwt = new jose.UnsecuredJWT(encryptData(data))
            .setIssuedAt()
            .setIssuer(window.location.origin)
            .setAudience(window.location.origin)
            .setExpirationTime('5m')
            .encode();
          return jwt;
    } catch {
        console.log("Failed to encrypt data.");
    }
}


const encryptData =(data)=>{

    const public_key = process.env.REACT_APP_PUBLIC_KEY;
    const aes_key = CryptoJS.lib.WordArray.random(32);
    const aes_iv = CryptoJS.lib.WordArray.random(16);
    const dataEnc = CryptoJS.AES.encrypt(data, aes_key, {
        iv: aes_iv,
    });

    const dataEncBase64 = CryptoJS.enc.Base64.stringify(dataEnc.ciphertext);

    const aes_key_hex = CryptoJS.enc.Hex.stringify(aes_key);
    const aes_iv_hex = CryptoJS.enc.Hex.stringify(aes_iv);

    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(public_key);
    const aes_key_enc = encrypt.encrypt(aes_key_hex);
    
    return {
        data: dataEncBase64,
        key: aes_key_enc,
        iv: aes_iv_hex,
    };
}